import getFrontConfig from '../getFrontConfig';

const {
  documentTypeValidation: { regexByDocumentType },
  countryCode,
} = getFrontConfig();

const getFirstCapturingGroup = (regex, str) => {
  const res = regex.exec(str);
  return res && res.length > 1 ? res[1] : null;
};

/**
 * Get regex by documentType and country
 * @param {string} selectedDocumentType - document type to get the regex for
 * @return {string} regex
 */
const getRegexByDocumentType = (selectedDocumentType) => {
  const regexByCountry = regexByDocumentType?.[countryCode];
  // Use the regex defined for the selected value in the json
  // Or use a default regex
  const currentRegex =
    selectedDocumentType && regexByCountry?.[selectedDocumentType];
  if (currentRegex) return currentRegex;
  return regexByCountry?.default || regexByDocumentType?.default || '[0-9]+';
};

export { getFirstCapturingGroup, getRegexByDocumentType };
